import TeethChart from './TeethChart'
import { useState, useEffect, useMemo } from 'react'
import Modal from './Modals'
import api from '../utils/Api'
import { Button, Row, Col, Form, Table } from 'react-bootstrap'
import { teethSideOptions } from '../modules/apps/treatment/treating/table/columns/data'
import Select from 'react-select';
import { reactSelectValue, inputOnlyPrice, inputOnlyNumber, reactSelectMultiValue } from '../utils/Helper'

export default function PatientTeethChart({ lineOa, patientId, usePrimaryTeeth }: any) {
  const [toothCharts, setToothCharts] = useState<any>([])
  const [showTeeth, setShowTeeth] = useState(false)
  const [currentTeeth, setCurrentTeeth] = useState(null)
  const [form, setForm] = useState<any>({ teethSide: [], teeth: '', treatmentItemId: null, patientId })
  const [options, setOptions] = useState<any>({ doctors: [], rooms: [], treatmentItems: [], patients: [] })
  const urlPrefix = lineOa ? 'line-oa/' : ''
  const charts = useMemo(() => {
    let selections = []
    for (let row of toothCharts) {
      selections.push({
        teeth: [row.teeth],
        teethSide: !!row.teethSide?.trim() ? [row.teethSide] : null,
        isSelection: false,
        isCross: row.treatmentItem.isExtraction
      })
    }

    return selections
  }, [toothCharts])

  const fetch = () => {
    api.request(urlPrefix + 'tooth-chart', (r, s) => {
      if (!s) return

      setToothCharts(r)
    }, { patientId })
  }

  useEffect(() => {
    if (!patientId) return

    fetch()

    if (lineOa) return

    api.request(urlPrefix + 'treatment-item', (res) => {
      setOptions((opt: any) => ({
        ...opt, treatmentItems: res.map((doctor: any) =>
          ({ ...doctor, label: `${doctor.code} - ${doctor.nameTh}`, value: doctor.id }))
      }
      ))
    }, { forDropdown: 1, type: 'service', selfBranch: true })
  }, [patientId])

  const ids = toothCharts.filter(({ teeth }: any) => teeth == currentTeeth).map(({ id }: any) => id)

  return (
    <>
      <TeethChart usePrimaryTeeth={usePrimaryTeeth} onSelect={(teeth) => {
        if (lineOa) return

        const editingChart = toothCharts.filter((r: any) => teeth == r.teeth)
        const sides = editingChart.map(({ teethSide }: any) => teethSide)
        const edit = editingChart.length ? {
          treatmentItemId: editingChart[0].treatmentItemId,
          teethSide: sides.length && sides[0] ? sides : []
        } : { teethSide: [] }

        setForm({ ...form, teeth, ...edit })
        setCurrentTeeth(teeth)
        setShowTeeth(true)
      }} selections={charts} />
      <Modal
        size="lg"
        show={showTeeth}
        centered
        onHide={() => {
          setShowTeeth(false)
        }}
        title={`แก้ไขซี่ฟันหมายเลข ${currentTeeth}`}
      >
        <Col xs={12}>
          <Form.Group as={Row} className="mb-5">
            <Form.Label>ด้าน</Form.Label>
            <Select
              classNamePrefix="react-select"
              options={teethSideOptions}
              name="teethSide"
              closeMenuOnSelect={false}
              onChange={(v) => {
                if (!v) {
                  setForm({ ...form, teethSide: [] })
                } else {
                  setForm({ ...form, teethSide: v.map(({ value }) => value) })
                }

              }}
              isMulti
              value={reactSelectMultiValue(teethSideOptions, form.teethSide || [])}
            />
          </Form.Group>
        </Col>
        <Col xs={12}>
          <Form.Group as={Row} className="mb-5">
            <Form.Label>รายการรักษา</Form.Label>
            <Select
              classNamePrefix="react-select"
              options={options.treatmentItems}
              name="treatmentItemId"
              onChange={({ value }: any) => setForm({ ...form, treatmentItemId: value })}
              value={reactSelectValue(options.treatmentItems, form.treatmentItemId)}
            />
          </Form.Group>
        </Col>
        <div className="row-center mt-3">
          <Button onClick={() => {
            setShowTeeth(false)
            let items = []

            if (form.teethSide.length > 0) {
              for (let teethSide of form.teethSide) {
                items.push({
                  ...form,
                  teethSide: teethSide
                })
              }
            } else {
              items = [{ ...form, teethSide: null }]
            }

            api.request('tooth-chart/bulk-update', (r, s) => {
              if (!s) return

              setShowTeeth(false)
              fetch()
            }, api.form({ items }), 'POST')
          }} variant="primary">บันทึก</Button>
          <Button className="ms-3" onClick={() => {
            setShowTeeth(false)

          }} variant="outline-primary">ยกเลิก</Button>
        </div>
        {!!ids.length &&
          <Col className="row-center mt-3">
            <a className="text-decoration-underline text-danger" href="#" onClick={(e) => {
              e.preventDefault()
              if (!window.confirm('การลบข้อมูลการรักษาซี่ฟันไม่สามารถย้อนกลับได้ ยืนยันการลบ?')) return

              api.request('tooth-chart/bulk-delete', (r, s) => {
                if (!s) return

                setShowTeeth(false)
                fetch()
              }, api.form({ ids }), 'DELETE')
            }}>ลบรายการซี่ฟันนี้</a>
          </Col>
        }
      </Modal>
    </>
  )
}
